import { render, staticRenderFns } from "./PlayRoutine.vue?vue&type=template&id=a38d51f2&scoped=true"
import script from "./PlayRoutine.vue?vue&type=script&lang=js"
export * from "./PlayRoutine.vue?vue&type=script&lang=js"
import style0 from "./PlayRoutine.vue?vue&type=style&index=0&id=a38d51f2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a38d51f2",
  null
  
)

export default component.exports